exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-manager-main-container .cookie-container{border:1px solid #4a4b53;margin:10px 5px;padding:5px;position:relative}.cookie-manager-main-container .cookie-container .description{font-size:12px;color:#acacac}.cookie-manager-main-container .cookie-container .toggle-list{font-size:12px}.cookie-manager-main-container .cookie-container .global-switcher{position:absolute;top:5px;right:5px}.cookie-manager-main-container .cookie-container .list-cookies{margin-top:15px;font-size:12px}.cookie-manager-main-container .cookie-container .header-cookie-list{font-weight:bolder}.cookie-manager-main-container .cookie-container .title-cook{margin-top:10px;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--2-2!./node_modules/sass-loader/lib/loader.js!./src-cookie-manager/views/pages/details/partials/container/style.scss
// module id = 436
// module chunks = 0